export default __webpack_public_path__ + "static/media/element_96.2ff21c88.webp";